export default __webpack_public_path__ + "assets/front/scss/classification-browsing.4c7ff031fc36cd7a98d44d749aa81176.css";